// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_6x-0";